import axios from 'axios'

import type { Company, Vessel } from './libraryModels'

const API_URL = process.env.REACT_APP_API_URL

const COMPANY_API_URL = `${API_URL}/users/company`
const VESSEL_API_URL = `${API_URL}/vessels`

export const getVesselTypeList = async (): Promise<Vessel[]> => {
  try {
    const response = await axios.get(VESSEL_API_URL)
    return response.data
  } catch (error: any) {
    // Keep message style consistent with existing codebase
    console.error('Error fetching vesel type list:', error)
    throw new Error(error.response?.data?.message || 'Error fetching vessel type list')
  }
}

export const getCompanyList = async (): Promise<Company[]> => {
  try {
    const response = await axios.get(COMPANY_API_URL)
    return response.data
  } catch (error: any) {
    console.error('Error fetching company list:', error)
    throw new Error(error.response?.data?.message || 'Error fetching company list')
  }
}

